import { defineMessages } from 'react-intl';
export default defineMessages({
    afternoon: {
        id: 'calendar.afternoon',
        defaultMessage: 'Afternoon'
    },
    april: {
        id: 'calendar.april',
        defaultMessage: 'April'
    },
    august: {
        id: 'calendar.august',
        defaultMessage: 'August'
    },
    changePeriod: {
        id: 'calendar.changePeriod',
        defaultMessage: 'Period: {period}. Change period'
    },
    currentDay: {
        id: 'calendar.currentDay',
        defaultMessage: 'Current day'
    },
    dateFormat: {
        id: 'calendar.dateFormat',
        defaultMessage: 'Date format'
    },
    day: {
        id: 'calendar.day',
        defaultMessage: 'Day'
    },
    december: {
        id: 'calendar.december',
        defaultMessage: 'December'
    },
    durationHours: {
        id: 'calendar.durationHours',
        defaultMessage: '{hours} hr'
    },
    durationHoursMinutes: {
        id: 'calendar.durationHoursMinutes',
        defaultMessage: '{hours} hr {minutes} min'
    },
    durationMinutes: {
        id: 'calendar.durationMinutes',
        defaultMessage: '{minutes} min'
    },
    durationMinutesSeconds: {
        id: 'calendar.durationMinutesSeconds',
        defaultMessage: '{minutes} min {seconds} s'
    },
    durationSeconds: {
        id: 'calendar.durationSeconds',
        defaultMessage: '{seconds} s'
    },
    endTime: {
        id: 'calendar.endTime',
        defaultMessage: 'End time'
    },
    evening: {
        id: 'calendar.evening',
        defaultMessage: 'Evening'
    },
    february: {
        id: 'calendar.february',
        defaultMessage: 'February'
    },
    goToNextDay: {
        id: 'calendar.goToNextDay',
        defaultMessage: 'Next day'
    },
    goToNextMonth: {
        id: 'calendar.goToNextMonth',
        defaultMessage: 'Next month'
    },
    goToNextWeek: {
        id: 'calendar.goToNextWeek',
        defaultMessage: 'Next week'
    },
    goToNextYear: {
        id: 'calendar.goToNextYear',
        defaultMessage: 'Next year'
    },
    goToPreviousDay: {
        id: 'calendar.goToPreviousDay',
        defaultMessage: 'Previous day'
    },
    goToPreviousMonth: {
        id: 'calendar.goToPreviousMonth',
        defaultMessage: 'Previous month'
    },
    goToPreviousWeek: {
        id: 'calendar.goToPreviousWeek',
        defaultMessage: 'Previous week'
    },
    goToPreviousYear: {
        id: 'calendar.goToPreviousYear',
        defaultMessage: 'Previous year'
    },
    hour: {
        id: 'calendar.hour',
        defaultMessage: 'Hour'
    },
    hoursCount: {
        id: 'calendar.hoursCount',
        defaultMessage: '{count, plural, one {# hour} other {# hours}}'
    },
    hoursShort: {
        id: 'calendar.hoursShort',
        defaultMessage: 'hrs'
    },
    hoursShortCount: {
        id: 'calendar.hoursShortCount',
        defaultMessage: '{count, plural, one {# hr} other {# hrs}}'
    },
    january: {
        id: 'calendar.january',
        defaultMessage: 'January'
    },
    july: {
        id: 'calendar.july',
        defaultMessage: 'July'
    },
    june: {
        id: 'calendar.june',
        defaultMessage: 'June'
    },
    last12Hours: {
        id: 'calendar.last12Hours',
        defaultMessage: 'Last 12 hours'
    },
    last24Hours: {
        id: 'calendar.last24Hours',
        defaultMessage: 'Last 24 hours'
    },
    last30Days: {
        id: 'calendar.last30Days',
        defaultMessage: 'Last 30 days'
    },
    last3Hours: {
        id: 'calendar.last3Hours',
        defaultMessage: 'Last 3 hours'
    },
    last6Hours: {
        id: 'calendar.last6Hours',
        defaultMessage: 'Last 6 hours'
    },
    last7Days: {
        id: 'calendar.last7Days',
        defaultMessage: 'Last 7 days'
    },
    lastHour: {
        id: 'calendar.lastHour',
        defaultMessage: 'Last Hour'
    },
    march: {
        id: 'calendar.march',
        defaultMessage: 'March'
    },
    max: {
        id: 'calendar.max',
        defaultMessage: 'Max'
    },
    may: {
        id: 'calendar.may',
        defaultMessage: 'May'
    },
    month: {
        id: 'calendar.month',
        defaultMessage: 'Month'
    },
    monthTotal: {
        id: 'calendar.monthTotal',
        defaultMessage: 'Month total'
    },
    morning: {
        id: 'calendar.morning',
        defaultMessage: 'Morning'
    },
    nextHours: {
        id: 'calendar.nextHours',
        defaultMessage: 'Next hours'
    },
    night: {
        id: 'calendar.night',
        defaultMessage: 'Night'
    },
    november: {
        id: 'calendar.november',
        defaultMessage: 'November'
    },
    october: {
        id: 'calendar.october',
        defaultMessage: 'October'
    },
    oneDay: {
        id: 'calendar.oneDay',
        defaultMessage: '1-day'
    },
    oneHour: {
        id: 'calendar.oneHour',
        defaultMessage: '1-hour'
    },
    oneMonth: {
        id: 'calendar.oneMonth',
        defaultMessage: '1-month'
    },
    oneWeek: {
        id: 'calendar.oneWeek',
        defaultMessage: '1-week'
    },
    periodRangeSpoken: {
        id: 'calendar.periodRangeSpoken',
        defaultMessage: '{start} to {end}'
    },
    previous24Hours: {
        id: 'calendar.previous24Hours',
        defaultMessage: 'Previous 24 hours'
    },
    previous30Days: {
        id: 'calendar.previous30Days',
        defaultMessage: 'Previous 30 days'
    },
    previous7Days: {
        id: 'calendar.previous7Days',
        defaultMessage: 'Previous 7 days'
    },
    previousDay: {
        id: 'calendar.previousDay',
        defaultMessage: 'Previous day'
    },
    previousHours: {
        id: 'calendar.previousHours',
        defaultMessage: 'Previous hours'
    },
    previousMonth: {
        id: 'calendar.previousMonth',
        defaultMessage: 'Previous month'
    },
    previousWeek: {
        id: 'calendar.previousWeek',
        defaultMessage: 'Previous week'
    },
    previousYear: {
        id: 'calendar.previousYear',
        defaultMessage: 'Previous year'
    },
    sameDayLastYear: {
        id: 'calendar.sameDayLastYear',
        defaultMessage: 'Same day last year'
    },
    sameMonthLastYear: {
        id: 'calendar.sameMonthLastYear',
        defaultMessage: 'Same month last year'
    },
    selectADate: {
        id: 'calendar.selectADate',
        defaultMessage: 'Select a date'
    },
    selectAMonth: {
        id: 'calendar.selectAMonth',
        defaultMessage: 'Select a month'
    },
    selectAYear: {
        id: 'calendar.selectAYear',
        defaultMessage: 'Select a year'
    },
    selectGranularity: {
        id: 'calendar.selectGranularity',
        defaultMessage: 'Select a granularity'
    },
    selectAggregation: {
        id: 'calendar.selectAggregation',
        defaultMessage: 'Select displayed value'
    },
    selectPeriod: {
        id: 'calendar.selectPeriod',
        defaultMessage: 'Select a period'
    },
    september: {
        id: 'calendar.september',
        defaultMessage: 'September'
    },
    sixHours: {
        id: 'calendar.sixHours',
        defaultMessage: '6-hour'
    },
    startTime: {
        id: 'calendar.startTime',
        defaultMessage: 'Start time'
    },
    thirtyMinutes: {
        id: 'calendar.thirtyMinutes',
        defaultMessage: '30-min'
    },
    threeHours: {
        id: 'calendar.threeHours',
        defaultMessage: '3-hour'
    },
    timezone: {
        id: 'calendar.timezone',
        defaultMessage: 'Timezone'
    },
    today: {
        id: 'calendar.today',
        defaultMessage: 'Today'
    },
    untilChanged: {
        id: 'calendar.untilChanged',
        defaultMessage: 'Until changed'
    },
    untilTime: {
        id: 'calendar.untilTime',
        defaultMessage: 'Until {time}'
    },
    untilTodayAt: {
        id: 'calendar.untilTodayAt',
        defaultMessage: 'Until today at {time}'
    },
    untilTomorrowAt: {
        id: 'calendar.untilTomorrowAt',
        defaultMessage: 'Until tomorrow at {time}'
    },
    use24HourFormat: {
        id: 'calendar.use24HourFormat',
        defaultMessage: 'Use 24-hour format'
    },
    week: {
        id: 'calendar.week',
        defaultMessage: 'Week'
    },
    year: {
        id: 'calendar.year',
        defaultMessage: 'Year'
    },
    yearToDate: {
        id: 'calendar.yearToDate',
        defaultMessage: 'Year to Date'
    },
    yesterday: {
        id: 'calendar.yesterday',
        defaultMessage: 'Yesterday'
    },
    earlierYears: {
        id: 'calendar.earlierYears',
        defaultMessage: 'Earlier years'
    },
    laterYears: {
        id: 'calendar.laterYears',
        defaultMessage: 'Later years'
    }
});
